module.exports = __webpack_public_path__ + "static/media/order_placed.fc2ea8d8.gif";